import { Injectable } from "@angular/core";
import { API_METHODS, API_URL, OperationType, ROUTE_PATH, USER_TYPE } from "common/constants/sm-constants";
import { environment } from "src/environments/environment";
import { ResetForgotPasswordModel } from "common/models/page-models/Login/reset-password/reset-password-data-model";
import { FormDataService } from "common/services/data-services/base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";


@Injectable({
    providedIn: 'root'
})
export class ResetForgotPasswordFormDataService extends FormDataService<ResetForgotPasswordModel> {
    
    constructor(http: SmApiService, protected override ss: SystemService) {
        super(API_URL.resetPassword, http, ss);
        

    }

    createInstance(): ResetForgotPasswordModel {
        return new ResetForgotPasswordModel();
    }

    // override modifyPostModel(formModel: any, dataModel: any) {
    //     const data = {
            
    //         email: dataModel.email
    //     }
    //     return data;
    // }

    override modifyPostModel(formModel: any, dataModel: any) {
        const data = {
            'email' : formModel.email,
            'temppassword':Number(formModel.temppassword),
            'newpassword':formModel.newpassword,
            'confirmpassword':formModel.confirmpassword
        }
        return data;
    }

    override getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + '',
            method: API_METHODS.get
        }
        return edit;
    }

    getAuthStatus(): boolean {
        // const username = this.systemService.st(this.systemService.getlocalStorage('username'))
        if (
            // this.ss.getlocalStorage('profile') !== null &&
            // this.ss.getlocalStorage('profile') !== undefined &&
            this.ss.getlocalStorage('token') !== null &&
            this.ss.getlocalStorage('token') !== undefined
        ) {
            return true;
        } else {
            // console.log("else part")
            this.ss.navigateToLogin();
            return false;
        }
    }

    // override afterPostData(model: ResetForgotPasswordModel, response): Promise<ResetForgotPasswordModel> {
    //     return new Promise<ResetForgotPasswordModel>((resolve, reject) => {
    //         this.ss.navigateToLogin();
    //         resolve(model);
    //     });
    // }

    // override getCustomError(): string {
    //     return 'Please enter correct Email ID';
    // }

}